var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30602 2.30799C4.89799 2.71865 4.89799 3.38445 5.30602 3.7951L9.47759 8L5.30602 12.2049C4.89799 12.6156 4.89799 13.2814 5.30602 13.692C5.71405 14.1027 6.37559 14.1027 6.78361 13.692L11.694 8.74356C12.102 8.3329 12.102 7.6671 11.694 7.25644L6.78361 2.30799C6.37559 1.89734 5.71405 1.89734 5.30602 2.30799Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.53cecb4f3649bc4fe6fb689592ebb5db.svg";
export { ForwardRef as ReactComponent };